import { Flex, Text, useTheme, Image } from "@aws-amplify/ui-react";

export function Footer() {
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={tokens.space.medium}>
      <Text>&copy; All Rights Reserved, Adly AB</Text>
      {/* <Image
        alt="logo"
        src="https://adly-campaigns.s3.eu-north-1.amazonaws.com/ADLY_FOR_WEBSITE_LOGO_FULL.png"
        height={25}
        marginLeft={-5}
      /> */}
    </Flex>
  );
}
